module.exports = __webpack_public_path__ + "static/media/color_lens_black_24dp.388d7bb4.svg";